// extracted by mini-css-extract-plugin
export default {"ourTeam":"ourteam_ourTeam__dbqDX","ourteamDescription":"ourteam_ourteamDescription__Ffjvg","ourteamMatesWrap":"ourteam_ourteamMatesWrap__vIqvY"};